import axios from 'axios';
import apiRequestHeaders from '../../common/apiRequestHeaders';

export interface N8nApprovalDecision {
  decisionReceived: boolean;
  autoApprove: boolean;
  reason: string | null;
  sendEmailToCleaner: boolean;
  sendEmailToCaretaker: boolean;
}

export function getN8nApprovalDecision(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .get<N8nApprovalDecision>(
      '/customerfeedback/customerfeedbacks/getn8napprovaldecision',
      config,
    )
    .then(res => res.data);
}
